<template>
    <FormSection
        title="Advance Care Plan/Admission"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template #content>
            <section class="col p-3 g-0">
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center sub-heading"><b>Admission</b></p>
                </div>
                <div class="ms-4">
                    <p class="field-title">
                        Does this patient have an advance care plan or a surrogate decision-maker AND able to provide
                        legal documentation for the home health medical record?
                        <i
                            class="fas fa-question-circle"
                            v-tooltip="{
                                title: `Select Yes if the patient has a DNR,MPOA,living will,other legally valid document or surrogate decision-maker`,
                                placement: 'top'
                            }"
                        ></i>
                    </p>
                    <div class="form-check custom-radio">
                        <input
                            class="form-check-input"
                            type="radio"
                            id="flexRadioDefault1"
                            :value="true"
                            v-model="referral.AdvancedDirectives.IsLegalDocumentation"
                        />
                        <label class="form-check-label" for="flexRadioDefault1"> Yes </label>
                    </div>
                    <div class="form-check custom-radio mt-4">
                        <input
                            class="form-check-input"
                            type="radio"
                            id="flexRadioDefault2"
                            :value="false"
                            v-model="referral.AdvancedDirectives.IsLegalDocumentation"
                        />
                        <label class="form-check-label" for="flexRadioDefault2"> No </label>
                    </div>
                </div>
                <div class="mt-4 ms-4 border-top border-top-3" v-if="referral.AdvancedDirectives.IsLegalDocumentation">
                    <div class="form-check custom-checkbox mt-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            name="advance_care"
                            id="advance_care"
                            v-model="referral.AdvancedDirectives.IsDirectiveDocumented"
                        />
                        <label class="form-check-label" for="advance_care">Advance Care Plan </label>
                    </div>
                    <div v-if="referral.AdvancedDirectives.IsDirectiveDocumented" class="ms-4">
                        <div
                            v-for="option of advancedCareSelectOptions"
                            :key="`${option.value}-${option.label}`"
                            class="form-check flex-column mt-2"
                        >
                            <div>
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`${option.label}-${option.value}`"
                                    :value="option.value"
                                    @change="handleCheckboxSelection(option.value)"
                                    :checked="
                                        referral.AdvancedDirectives.AdvancedDirectivesIntentsCollection.includes(
                                            option.value
                                        )
                                    "
                                />
                                <label class="form-check-label" :for="`${option.label}-${option.value}`">{{
                                    option.label
                                }}</label>
                            </div>
                            <div
                                v-if="
                                    referral.AdvancedDirectives.AdvancedDirectivesIntentsCollection.includes(
                                        'Power of Attorney for Health'
                                    ) && option.value === 'Power of Attorney for Health'
                                "
                            >
                                <div class="form-group">
                                    <label id="Name" for="Name"> Name </label>
                                    <input
                                        id="Name"
                                        name="name"
                                        class="form-control"
                                        type="text"
                                        placeholder="Enter Name"
                                        v-model="referral.AdvancedDirectives.AdvanceCarePlanName"
                                    />
                                </div>
                                <div class="form-group">
                                    <label id="Relationship" for="Relationship"> Relationship </label>
                                    <input
                                        id="Relationship"
                                        name="Relationship"
                                        class="form-control"
                                        type="text"
                                        placeholder="Enter Relationship"
                                        v-model="referral.AdvancedDirectives.AdvanceCarePlanRelationship"
                                    />
                                </div>
                            </div>
                            <div
                                v-if="
                                    referral.AdvancedDirectives.AdvancedDirectivesIntentsCollection.includes(
                                        'Other Valid Documents'
                                    ) && option.value === 'Other Valid Documents'
                                "
                                class="form-group"
                            >
                                <label id="Name" for="Name"> </label>
                                <input id="Name" name="name" class="form-control" type="text" />
                            </div>
                        </div>
                        <div class="mt-4">
                            <p>
                                If any of the following information is documented in the patient's advanced plan of
                                care, please specify below.
                            </p>
                            <div class="form-group">
                                <label id="Medical Treatment Preferences" for="Medical Treatment Preferences"
                                    >Medical Treatment Preferences
                                </label>
                                <input
                                    id="Medical Treatment Preferences"
                                    name="Medical Treatment Preferences"
                                    class="form-control"
                                    type="text"
                                    placeholder="Enter Medical Treatment Preferences"
                                    v-model="referral.AdvancedDirectives.AdvancedDirectivesPreferenceMedical"
                                />
                            </div>
                            <div class="form-group">
                                <label
                                    id="Enter Mental Health/Behavioral Treatment Preferences"
                                    for="Enter Mental Health/Behavioral Treatment Preferences"
                                    >Enter Mental Health/Behavioral Treatment Preferences
                                </label>
                                <input
                                    id="Enter Mental Health/Behavioral Treatment Preferences"
                                    name="Enter Mental Health/Behavioral Treatment Preferences"
                                    class="form-control"
                                    type="text"
                                    placeholder="Enter Mental Health/Behavioral Treatment Preferences"
                                    v-model="referral.AdvancedDirectives.AdvancedDirectivesPreferenceMental"
                                />
                            </div>
                            <div class="form-group">
                                <label id="Enter Cultural/Social Preferences" for="Enter Cultural/Social Preferences"
                                    >Enter Cultural/Social Preferences
                                </label>
                                <input
                                    id="Enter Cultural/Social Preferences"
                                    name="Enter Cultural/Social Preferences"
                                    class="form-control"
                                    type="text"
                                    placeholder="Enter Cultural/Social Preferences"
                                    v-model="referral.AdvancedDirectives.AdvancedDirectivesPreferenceCultural"
                                />
                            </div>
                            <div class="form-group">
                                <label
                                    id="Enter Spiritual/Religious Preferences"
                                    for="Enter Spiritual/Religious Preferences"
                                    >Enter Spiritual/Religious Preferences
                                </label>
                                <input
                                    id="Enter Spiritual/Religious Preferences"
                                    name="Enter Spiritual/Religious Preferences"
                                    class="form-control"
                                    type="text"
                                    placeholder="Enter Spiritual/Religious Preferences"
                                    v-model="referral.AdvancedDirectives.AdvancedDirectivesPreferenceSpiritual"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-check custom-checkbox mt-4">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            name="surrogate"
                            id="surrogate"
                            v-model="referral.AdvancedDirectives.IsSurrogateDocumented"
                        />
                        <label class="form-check-label" for="surrogate"> Surrogate Decision-Maker </label>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>
<style scoped>
.form-group {
    width: 90%;
}
</style>
<script lang="ts" src="./AdvanceCarePlan.ts"></script>
